// Caminho relativo: src/app/components/pipes/local-date-time.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from "moment";

@Pipe({
  name: 'localDateTime'
})
export class LocalDateTimePipe implements PipeTransform {

  transform(date: string): string {
    let dateOut: moment.Moment = moment(date, "YYYY-MM-DDThh:mm:ss.sTZD")
    return dateOut.format("DD/MM/YY HH:mm");
  }

}
